var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_8263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54594 9.66966L2.989 11.7488L0.953406 11.7918C0.345063 10.6635 0 9.37253 0 8.00066C0 6.67407 0.322625 5.42306 0.8945 4.32153H0.894938L2.70719 4.65378L3.50106 6.45516C3.33491 6.93957 3.24434 7.45957 3.24434 8.00066C3.24441 8.58791 3.35078 9.15057 3.54594 9.66966Z",
    fill: "#FFCD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8601 6.50659C15.952 6.99053 15.9999 7.49031 15.9999 8.00109C15.9999 8.57384 15.9397 9.13253 15.825 9.67143C15.4355 11.5053 14.4179 13.1066 13.0083 14.2398L13.0078 14.2393L10.7252 14.1229L10.4022 12.1062C11.3375 11.5576 12.0685 10.6991 12.4536 9.67143H8.17578V6.50659H12.516H15.8601Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0076 14.2384L13.0081 14.2388C11.6371 15.3408 9.89553 16.0002 7.99972 16.0002C4.95313 16.0002 2.30434 14.2973 0.953125 11.7914L3.54566 9.66919C4.22125 11.4723 5.96059 12.7558 7.99972 12.7558C8.87619 12.7558 9.69731 12.5188 10.4019 12.1052L13.0076 14.2384Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1064 1.84175L10.5148 3.9635C9.78553 3.50769 8.92353 3.24437 8.00003 3.24437C5.91475 3.24437 4.14288 4.58678 3.50113 6.4545L0.894969 4.32088H0.894531C2.22597 1.75384 4.90816 0 8.00003 0C9.94113 0 11.7209 0.691437 13.1064 1.84175Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_8263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.8ff585ac.svg";
export { ForwardRef as ReactComponent };